export default __webpack_public_path__ + "static/media/howWorkmobile.37b7f30f.png";